import React from "react";
import { ReactComponent as CheckIcon } from "assets/bruial/checkBoxIcon.svg";
import type { IBurialPlotsName } from "service/interface/burial";
import { cls } from "shared/lib/util/classnames";

interface Props {
  label: IBurialPlotsName;
  isSelect: boolean;
  onClick: ({ nameNum, name }: IBurialPlotsName) => void;
}

export function BurialPlotsSelectBtn({ label, isSelect, onClick }: Props) {
  return (
    <div
      onClick={() => onClick(label)}
      className={cls(
        isSelect
          ? "border-[#ffb067] bg-[#fff9de]"
          : "border-[#dfe3e6] bg-white",
        "flex h-[74px] w-[245px] cursor-pointer items-center justify-between rounded-[16px] border-[1px] pl-[32px] pr-[16px]",
      )}
    >
      <p
        className={cls(
          isSelect ? "text-[#ffb067]" : "text-[#9f9f9f]",
          "text-[18px] font-medium",
        )}
      >
        {label.name}
      </p>
      <CheckIcon
        className={cls(
          isSelect && "[&>*:nth-child(1)]:[&>*:nth-child(3)]:fill-[#ffb067]",
        )}
      />
    </div>
  );
}
